/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import getOr from 'lodash/fp/getOr.js';
import get from 'lodash/fp/get.js';
import keys from 'lodash/fp/keys.js';
import { underscoreErrorRegex } from '@hbrisk/sp3-risk-model-support/regularExpressions.js';
import getFieldsFlattenedWithErrors from '#support/utility/form/validation/getFieldsFlattenedWithErrors/index.js';
import getTouchedFromMeta from '#support/utility/form/getTouchedFromMeta/index.js';

const countFieldArrayItemErrors = (name, index, errors, meta) => {
  const itemPath = `${name}[${index}]`;
  // Note: the following line, unlike errorItem = getOr({}, itemPath, errors), assigns {}
  // to errorItem, when get(itemPath, errors) === null
  const errorItem = get(itemPath, errors) || {};
  const fieldsWithErrors = getFieldsFlattenedWithErrors(errorItem);
  const touchedFields = getTouchedFromMeta(getOr({}, itemPath, meta));
  return keys(fieldsWithErrors).reduce((acc, field) => {
    const res = get(field, touchedFields) !== undefined || underscoreErrorRegex.test(field);
    return acc + (res ? fieldsWithErrors[field] : 0);
  }, 0);
};

export default countFieldArrayItemErrors;
